import { ExportIcon } from "@xola/icons";
import React from "react";
import { useQuery } from "react-query";
import { ExportJob } from "types";
import { api } from "../../../api/api";
import { useModal } from "../../../hooks/useVisibility";
import { useXolaBotEarningsReportFilterStore } from "../../../stores/reports/xolabotEarningsReportFilterStore";
import { ExportJobModal } from "../../Common/ExportJobModal";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { EarningsReportTransactionsList, getXolaBotEarningReportParams } from "./XolaBotEarningsReportTransactionsList";

export const XolaBotEarningsReportTransactions = () => {
    const exportModal = useModal();

    const filters = useXolaBotEarningsReportFilterStore((state) => state.filters);
    const dateParams = useXolaBotEarningsReportFilterStore((state) => state.getDateParams());
    const params = getXolaBotEarningReportParams(dateParams, filters, "xlsx");

    return (
        <div className="w-full px-6 pb-20">
            <div className="flex items-center justify-end p-2">
                <div className="flex items-center justify-between">
                    <SecondaryButton icon={<ExportIcon />} onClick={exportModal.show}>
                        Export Transactions
                    </SecondaryButton>
                </div>
            </div>
            <EarningsReportTransactionsList />
            <ExportPurchasesModal isOpen={exportModal.isVisible} params={params} onClose={exportModal.hide} />
        </div>
    );
};

interface ExportPurchasesModalProps {
    isOpen: boolean;
    onClose: (e: any) => void;
    params: any;
}

const ExportPurchasesModal = ({ isOpen, onClose, params }: ExportPurchasesModalProps) => {
    const { data: job } = useQuery<ExportJob>(
        ["purchases", "collection", params],
        async () => {
            const { data } = await api.get<ExportJob>("/purchases", { params });
            return data;
        },
        { enabled: isOpen },
    );

    return <ExportJobModal isOpen={isOpen} job={job} onClose={onClose} />;
};
